import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { WEEK_DAYS } from '@/values/general.values';
import { PlaceholderService } from '@/tools/services/placeholder.service';

@Component({
  name: 'ed-class-change-main-placeholder-modal',
  components: {
    EdAssignMainPlaceholder: () => import(/* EdAssignMainPlaceholder */'@/tools/components/class-builder/ed-assign-main-placeholder/ed-assign-main-placeholder.component.vue'),
  }
})
export default class EdClassChangeMainPlaceholderModalComponent extends Vue {
  @Prop({ default: null }) readonly params: any;

  isChangingPlaceholder = false;
  assignChanges: any = [];

  get scheduleDetails() {
    return this.params.scheduleDetails;
  }

  get weekday() {
    return this.params.weekday;
  }

  get weekdayString() {
    return WEEK_DAYS[this.params.weekday];
  }

  get startTime() {
    return this.params.start;
  }

  get endTime() {
    return this.params.end;
  }

  get formattedSchedule() {
    let formattedSchedule = [];
    
    Object.entries(this.scheduleDetails).forEach(([date, schedules]: any[]) => {
      const weekDay = new Date(date).getUTCDay();

      if (weekDay === this.weekday) {
        schedules.forEach((schedule) => {
          if (schedule.startTime === this.startTime && schedule.endTime === this.endTime) {
            formattedSchedule.push({ date, schedule });
          }
        })
      }
    });
    return formattedSchedule;
  }

  formatTime(time) {
    const [hour, minute] = time.split(':');
    if(hour > 12) {
      return `${hour - 12} PM`
    }
    return `${hour} AM`
  }

  close() {
    this.isChangingPlaceholder = false;
    this.$EdModal.closeModal();
  }

  handleSelectPlaceholder(data) {
    if(data === null) return;
    this.assignChanges.push(data)
  }

  async handleSave() {
    this.formattedSchedule.forEach((schedule) => {
      if(this.$refs[`assign${schedule.date}`]) this.$refs[`assign${schedule.date}`][0].selectPlaceholder();
    })
    const dates = this.assignChanges
      .map((change) => {
        return {
          placeholderId: change.placeholderId,
          date: change.date,
        }
      })
    await PlaceholderService.assignPlaceholdersToSchedule(
      Number(this.$route.params.classId),
      this.assignChanges[0].entryId,
      dates
    )
    this.$nextTick(() => {
      this.$edEventBus.$emit('refetchAssingMainPlaceholder')
      this.assignChanges = [];
      this.close();
    })
  }

  @Watch('isChangingPlaceholder')
  onIsChangingPlaceholderChange() {
    this.formattedSchedule.forEach((schedule) => {
      if(this.$refs[`assign${schedule.date}`]) this.$refs[`assign${schedule.date}`][0].reset();
    })
  }
}